export default "__VITE_ASSET__BBFmm8e4__"